export const formatPrice = (cents: number, currency: string = 'CDF'): string => {
  const amount = cents / 100;
  
  switch (currency) {
    case 'CDF':
      // Format: 1 234,56 FC
      return new Intl.NumberFormat('fr-CD', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(amount) + ' FC';
    
    case 'USD':
      // Format: $1,234.56
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(amount);
    
    case 'EUR':
      // Format: 1 234,56 €
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
      }).format(amount);
    
    default:
      // Fallback format
      return `${amount.toFixed(2)} ${currency}`;
  }
};

export const formatPriceWithCurrency = (priceInCents: number, originalCurrency: string, displayCurrency: string, convertPrice: (price: number, from: string, to: string) => number): string => {
  // Si les devises sont identiques, pas besoin de conversion
  if (originalCurrency === displayCurrency) {
    return formatPrice(priceInCents, displayCurrency);
  }
  
  // Sinon, convertir puis formater
  const convertedPrice = convertPrice(priceInCents, originalCurrency, displayCurrency);
  return formatPrice(convertedPrice, displayCurrency);
};

export const parsePriceInput = (input: string): number => {
  // Remove all non-numeric characters except decimals
  const cleanedInput = input.replace(/[^\d.,]/g, '');
  
  // Handle different decimal separators
  const normalizedInput = cleanedInput.replace(',', '.');
  
  // Parse to float and convert to cents
  const amount = parseFloat(normalizedInput) || 0;
  return Math.round(amount * 100);
};

export const getCurrencySymbol = (currency: string): string => {
  switch (currency) {
    case 'CDF':
      return 'FC';
    case 'USD':
      return '$';
    case 'EUR':
      return '€';
    default:
      return currency;
  }
};